@if(totalNumOfAlarms > minNumOfAlarms) {
<div class="loren-alarms-table-actions">
  <div class="loren-alarms-table-actions-num">
    <span
      >{{ alarmsOnPage < totalNumOfAlarms ? alarmsOnPage : totalNumOfAlarms }}
      {{ "alarms.out_of" | transloco }} {{ totalNumOfAlarms }}</span
    >
    <mat-form-field
      class="loren-form-field loren-alarms-table-actions-select"
      appearance="outline">
      <mat-select
        [disabled]="totalNumOfAlarms <= minNumOfAlarms"
        [value]="numOfAlarms()"
        (selectionChange)="handleSelectionChange($event.value)">
        <mat-option [value]="20">20</mat-option>
        <mat-option [value]="40">40</mat-option>
        <mat-option [value]="60">60</mat-option>
        <mat-option [value]="80">80</mat-option>
        <mat-option [value]="100">100</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="loren-alarms-table-actions-more">
      <button
              matButton="filled"
              class="btn-secondary"
              [disabled]="totalNumOfAlarms < numOfAlarms() || scrollNumber() === 0"
              (click)="changeAlarms(-1)"
      >
      <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
    <button
      matButton="filled"
      class="btn-secondary"
      [disabled]="alarmsOnPage >= totalNumOfAlarms"
      (click)="changeAlarms(1)">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
  </div>
</div>
}
